module.exports = __webpack_public_path__ + "img/spices.1d2c7a7a.jpg";